import AbstractDataAdapter from './AbstractDataAdapter';

class LookupValueDataAdapter extends AbstractDataAdapter {
  /**
   *
   * @returns {string[]}
   */
  static get allowedFields() {
    return ['type', 'value', 'projectId'];
  }

  /**
   *
   * @returns {string[]}
   */
  static get requiredFields() {
    return ['type', 'value', 'projectId'];
  }
}

export default LookupValueDataAdapter;
